import { isMobile } from "react-device-detect";
import { Link, useParams } from "react-router-dom";

import BuyButton from "./components/buy-button";

import "./toys-details.scss";
import { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import { CartContext } from "../../contexts/cartContext";
import { getBasePath } from "./../../helpers";
import { LoadingContext } from "../../contexts/loadingContext";

const daysByPeriodKey = {
  weekly_price: 7,
  bimonthly_price: 60,
  monthly_price: 30,
  quarterly_price: 90,
  semiannual_price: 180,
};

function ToysDetails() {
  const [toy, setToy] = useState();
  const [relatedToys, setRelatedToys] = useState([]);
  const [selectedRental, setSelectedRental] = useState(null);

  const [rentPlans, setRentPlans] = useState([]);

  const { toyId } = useParams();

  const { setIsLoadingGlobal } = useContext(LoadingContext);

  const { addCartItem } = useContext(CartContext);

  const calcRentPlans = (responseToy) => {
    const tempRentPlans = [];
    for (const key of Object.keys(responseToy)) {
      if (
        key === "weekly_price" ||
        key === "bimonthly_price" ||
        key === "biweekly_price" ||
        key === "monthly_price" ||
        key === "quarterly_price" ||
        key === "semiannual_price"
      ) {
        if (responseToy[key]) {
          tempRentPlans.push({
            name: key,
            days: daysByPeriodKey[key],
            value: responseToy[key],
          });
        }
      }
    }
    setRentPlans(tempRentPlans);
  };

  const getToyData = (id) => {
    setIsLoadingGlobal(true);
    api
      .get(`/toys/${id}`)
      .then((response) => {
        const responseData = response.data.data;
        setToy(responseData);
        calcRentPlans(responseData);
        setIsLoadingGlobal(false);
      })
      .catch(() => setIsLoadingGlobal(false));
  };

  useEffect(() => {
    if (!toyId) return null;
    getToyData(toyId);
  }, [toyId]);

  let buyButton = {
    state: "",
    background: "",
    text: "",
    icon: ``,
  };

  function stateBuyButton() {
    switch (buyButton.state) {
      case "added":
        buyButton.background = "#5E61DE";
        buyButton.text = "Adicionado ao carrinho";
        buyButton.icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="currentColor"
            className="bi bi-check2"
            viewBox="0 0 16 16"
          >
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
          </svg>
        );
        break;
      case "rented":
        buyButton.background = "#EE3A3A";
        buyButton.text = "Alugado";
        buyButton.icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="currentColor"
            className="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        );
        break;
      default:
        buyButton.background = "#4ECB71";
        buyButton.text = "Adicionar ao carrinho";
        buyButton.icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="currentColor"
            className="bi bi-cart"
            viewBox="0 0 16 16"
          >
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
        );
        buyButton.onClickCallback = () => {
          addCartItem({
            ...toy,
            selectedRental: {
              name: selectedRental,
              value: toy[selectedRental],
              period: daysByPeriodKey[selectedRental],
            },
          });
        };
    }
  }

  if (!toy) return null;

  return (
    <div
      className="container-fluid toys-page"
      style={isMobile ? { padding: "2rem 0.8rem" } : { padding: "0 0 4rem 0" }}
    >
      <div className="container-xxl gap-3 breadcrumb">
        <Link className="bread-link link" to={"/"}>
          Home
        </Link>
        <span className="bread-link">|</span>
        <Link className="bread-link link" to={"/brinquedos-adoleta"}>
          Brinquedos
        </Link>
        <span className="bread-link">|</span>
        <span className="bread-link">{toy.name}</span>
      </div>
      <div
        className={`container-xxl gap-4 ${
          isMobile ? "" : "d-flex"
        } toy-content`}
      >
        <div
          className={`toy-carousel ${isMobile ? "toy-carousel-mobile" : ""}`}
        >
          <div id="carouselToysImages" className="carousel carousel-dark slide">
            <div
              className={`carousel-inner images-container ${
                isMobile ? "images-container-mobile" : ""
              }`}
            >
              <div className="carousel-item active">
                <img
                  src={`${getBasePath()}/${toy.cover_image.image}`}
                  className="d-block w-100 img-fluid"
                  alt="Imagem ilustrativa"
                />
              </div>
              {toy.images.map((image) => (
                <div className="carousel-item" key={image.id}>
                  <img
                    src={`${getBasePath()}/${image.image}`}
                    className="d-block w-100 img-fluid"
                    alt="Imagem ilustrativa"
                  />
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev button-control"
              type="button"
              data-bs-target="#carouselToysImages"
              data-bs-slide="prev"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-chevron-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </button>
            <button
              className="carousel-control-next button-control"
              type="button"
              data-bs-target="#carouselToysImages"
              data-bs-slide="next"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-chevron-right"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </button>
          </div>
          <div className="carousel-indicators flex-column align-items-center">
            <div className="d-flex justify-content-center indicators">
              <button
                type="button"
                data-bs-target="#carouselToysImages"
                data-bs-slide-to="0"
                aria-current="true"
                aria-label="Slide 1"
              >
                <img
                  src={`${getBasePath()}/${toy.cover_image.image}`}
                  className="d-block img-fluid"
                  alt="Imagem de capa ilustrativa"
                />
              </button>
              {toy.images.map((image, index) => (
                <button
                  type="button"
                  data-bs-target="#carouselToysImages"
                  data-bs-slide-to={index + 1}
                  aria-label={`Slide ${index + 2}`}
                >
                  <img
                    src={`${getBasePath()}/${image.image}`}
                    className="d-block img-fluid"
                    alt="Imagem ilustrativa"
                  />
                </button>
              ))}
            </div>
            <h6 className="text-center subtitle">
              Imagen(s) meramente ilustrativas
            </h6>
          </div>
        </div>
        <div className="d-flex flex-column toy-texts ms-auto">
          <div className="toy-titles">
            <p className="toy-text">{toy.brand.name}</p>
            <h1 className="toy-title">{toy.name}</h1>
          </div>
          <div className="toy-payments-list">
            {rentPlans.map((rentPlan) => (
              <div className="toy-payment">
                <p className="toy-price">R$ {rentPlan.value}</p>
                <p className="toy-period">
                  <strong>Período: </strong>
                  {rentPlan.days} dias
                </p>
              </div>
            ))}
          </div>
          <div className="toy-info">
            <h6>
              <strong>Disponibilidade: </strong>
              {toy.city} - {toy.state}
            </h6>
            <div className="d-flex align-items-baseline">
              <h6>
                <strong>Faixa Etária: </strong>
              </h6>
              <ul>
                {toy.age_ranges.map((range) => (
                  <li key={range.id}>{range.label}</li>
                ))}
              </ul>
            </div>
            <div className="d-flex align-items-baseline">
              <h6>
                <strong>Estímulo: </strong>
              </h6>
              <ul>
                {toy.stimulis.map((stimuli) => (
                  <li key={stimuli.id}>{stimuli.name}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="d-flex">
            <select
              className="select-rental-plan"
              onChange={(e) => {
                const { value } = e.target;
                setSelectedRental(value);
              }}
            >
              <option value={0}>Planos de aluguel</option>
              {rentPlans.map((rentPlan) => (
                <option value={rentPlan.name}>
                  R$ {rentPlan.value} - Período: {rentPlan.days} dias
                </option>
              ))}
            </select>
            <div className="buy-button ms-3">
              {stateBuyButton()}
              <BuyButton
                background={buyButton.background}
                text={buyButton.text}
                icon={buyButton.icon}
                state={buyButton.state}
                onClickCallback={buyButton.onClickCallback}
                disabled={!selectedRental || selectedRental == "0"}
              />
            </div>
          </div>
          <div className="toy-info-details">{toy.description}</div>
        </div>
      </div>
      {relatedToys.length > 0 && (
        <>
          <div
            className="container-xxl d-flex flex-column align-items-center might-like"
            style={isMobile ? { marginTop: "4rem" } : { marginTop: "10rem" }}
          >
            <h1 style={isMobile ? { fontSize: "36px" } : { fontSize: "48px" }}>
              Seu filho também poderá gostar de:
            </h1>
            {/* <div className="row row-cols-4 d-flex justify-content-center gap-4">
          {mockData.map((toy, index) => (
            <CardToy className="col" key={index} toyData={toy} />
          ))}
        </div> */}
          </div>
          <div
            className="container-xxl d-flex align-items-center justify-content-center see-more"
            style={isMobile ? { marginTop: "2rem" } : { marginTop: "6rem" }}
          >
            <Link className="d-flex see-more-button" to={"/brinquedos-adoleta"}>
              <button className="w-100 h-100 text-center">
                VER OUTROS BRINQUEDOS
              </button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default ToysDetails;
